module.exports = __webpack_public_path__ + "img/sdv-logo-white-150.f6fbc13e.png";